import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import api from '@/lib/api';
import { toast } from 'sonner';

export default function SellerSettings() {
  const { seller, refreshSeller } = useOutletContext();
  const [form, setForm] = useState({
    shop_name: seller?.shop_name || '',
    description: seller?.description || '',
    address: seller?.address || '',
    pincode: seller?.pincode || '',
    mobile: seller?.mobile || '',
    delivery_mode: seller?.delivery_mode || 'both',
    logo_url: seller?.logo_url || '',
    banner_url: seller?.banner_url || '',
  });
  const [busy, setBusy] = useState(false);
  const upd = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch('/sellers/me', form);
      await refreshSeller();
      toast.success('Store updated');
    } catch (e) { toast.error('Failed to save'); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl space-y-5" data-testid="seller-settings">
      <h1 className="font-heading text-3xl text-stone-900">Store settings</h1>
      <form onSubmit={save} className="bg-white rounded-2xl border border-stone-200 p-5 space-y-3">
        <L label="Shop name"><input className="inp" value={form.shop_name} onChange={(e) => upd('shop_name', e.target.value)}/></L>
        <L label="Description"><textarea rows="3" className="inp" value={form.description} onChange={(e) => upd('description', e.target.value)}/></L>
        <div className="grid grid-cols-2 gap-3">
          <L label="PIN code"><input className="inp" value={form.pincode} onChange={(e) => upd('pincode', e.target.value.replace(/[^0-9]/g,'').slice(0,6))}/></L>
          <L label="Mobile"><input className="inp" value={form.mobile} onChange={(e) => upd('mobile', e.target.value.replace(/[^0-9]/g,'').slice(0,12))}/></L>
        </div>
        <L label="Address"><input className="inp" value={form.address} onChange={(e) => upd('address', e.target.value)}/></L>
        <L label="Delivery mode">
          <select className="inp" value={form.delivery_mode} onChange={(e) => upd('delivery_mode', e.target.value)}>
            <option value="self">Vendor delivery / pickup only</option>
            <option value="platform">Platform delivery only</option>
            <option value="both">Both (choose per order)</option>
          </select>
        </L>
        <div className="grid grid-cols-2 gap-3">
          <L label="Logo URL"><input className="inp" value={form.logo_url} onChange={(e) => upd('logo_url', e.target.value)}/></L>
          <L label="Banner URL"><input className="inp" value={form.banner_url} onChange={(e) => upd('banner_url', e.target.value)}/></L>
        </div>
        <button disabled={busy} type="submit" data-testid="seller-settings-save" className="h-10 px-5 rounded-full bg-terracotta-600 text-white text-sm font-semibold hover:bg-terracotta-700 disabled:bg-stone-300">{busy ? 'Saving…' : 'Save changes'}</button>
        <style>{`.inp{width:100%;height:40px;padding:0 12px;border:1px solid #e7e5e4;border-radius:10px;font-size:14px;background:white;}textarea.inp{height:auto;padding:10px 12px;}`}</style>
      </form>
    </div>
  );
}

function L({ label, children }) { return <div><label className="text-xs font-medium text-stone-600 block mb-1">{label}</label>{children}</div>; }
